export const FilesInfo = [ {
  "id" : 0,
  "name" : "Военная топография",
  "files" : [ {
    "name" : "Документ Microsoft Word",
    "id" : 1,
    "size" : "141,40 KB",
    "extension" : ".docx"
  }, {
    "name" : "определени сторон света",
    "id" : 2,
    "size" : "73,05 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема  2.2 топограф   разв",
    "id" : 3,
    "size" : "795,50 KB",
    "extension" : ".doc"
  }, {
    "name" : "Тема 1.1",
    "id" : 4,
    "size" : "147,12 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 1.2",
    "id" : 5,
    "size" : "170,41 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.1",
    "id" : 6,
    "size" : "515,50 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.1",
    "id" : 7,
    "size" : "1,28 MB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.2",
    "id" : 8,
    "size" : "186,04 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.3",
    "id" : 9,
    "size" : "670,97 KB",
    "extension" : ".docx"
  } ]
}, {
  "id" : 1,
  "name" : "Военно медицинская подготовка",
  "files" : [ {
    "name" : "мед 3.1  разв",
    "id" : 10,
    "size" : "2,60 MB",
    "extension" : ".doc"
  }, {
    "name" : "мед 3.2  разв",
    "id" : 11,
    "size" : "2,59 MB",
    "extension" : ".doc"
  }, {
    "name" : "мед 4.1 разв",
    "id" : 12,
    "size" : "80,00 KB",
    "extension" : ".doc"
  }, {
    "name" : "Тема 1.1",
    "id" : 13,
    "size" : "17,91 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.1",
    "id" : 14,
    "size" : "48,07 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.2",
    "id" : 15,
    "size" : "60,03 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.3",
    "id" : 16,
    "size" : "88,96 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.4",
    "id" : 17,
    "size" : "2,96 MB",
    "extension" : ".doc"
  }, {
    "name" : "Тема 2.5",
    "id" : 18,
    "size" : "27,03 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.6",
    "id" : 19,
    "size" : "57,19 KB",
    "extension" : ".docx"
  } ]
}, {
  "id" : 2,
  "name" : "Гажданское воспитание",
  "files" : [ {
    "name" : "Civica_T_2_2020",
    "id" : 20,
    "size" : "1,73 MB",
    "extension" : ".ppt"
  }, {
    "name" : "гражд воспитаниеТ4  зан 1 разв",
    "id" : 21,
    "size" : "170,00 KB",
    "extension" : ".doc"
  }, {
    "name" : "гражд воспитаниеТ4  зан 1",
    "id" : 22,
    "size" : "32,00 KB",
    "extension" : ".doc"
  }, {
    "name" : "Гражданско вспитание т1",
    "id" : 23,
    "size" : "814,50 KB",
    "extension" : ".ppt"
  } ]
}, {
  "id" : 3,
  "name" : "ДРОНЫ",
  "files" : [ {
    "name" : "_eDronne Tema 1",
    "id" : 24,
    "size" : "1,95 MB",
    "extension" : ".ppsx"
  }, {
    "name" : "_eDronne Tema 2_1",
    "id" : 25,
    "size" : "3,43 MB",
    "extension" : ".ppsx"
  }, {
    "name" : "_eDronne Tema 2_2",
    "id" : 26,
    "size" : "4,47 MB",
    "extension" : ".ppsx"
  }, {
    "name" : "_eDronne Tema 2_3",
    "id" : 27,
    "size" : "2,84 MB",
    "extension" : ".ppsx"
  }, {
    "name" : "_eDronne Tema 3_1",
    "id" : 28,
    "size" : "2,94 MB",
    "extension" : ".ppsx"
  }, {
    "name" : "_eDronne Tema 3_2",
    "id" : 29,
    "size" : "5,34 MB",
    "extension" : ".ppsx"
  } ]
}, {
  "id" : 4,
  "name" : "ЗОМП",
  "files" : [ {
    "name" : "ЗОМП 2.1.разв",
    "id" : 30,
    "size" : "998,00 KB",
    "extension" : ".doc"
  }, {
    "name" : "Тема 1.1",
    "id" : 31,
    "size" : "135,37 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 1.2",
    "id" : 32,
    "size" : "38,21 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 1.3",
    "id" : 33,
    "size" : "41,81 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.2 зомп",
    "id" : 34,
    "size" : "110,60 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.1",
    "id" : 35,
    "size" : "28,48 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 4.1",
    "id" : 36,
    "size" : "26,22 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 4.2",
    "id" : 37,
    "size" : "587,48 KB",
    "extension" : ".docx"
  } ]
}, {
  "id" : 5,
  "name" : "Инженерная подготовка",
  "files" : [ {
    "name" : "инж т1 .1 разв",
    "id" : 38,
    "size" : "262,77 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 1.2",
    "id" : 39,
    "size" : "126,79 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 1.3",
    "id" : 40,
    "size" : "431,40 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.1 инженерная",
    "id" : 41,
    "size" : "1,44 MB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.1",
    "id" : 42,
    "size" : "1,44 MB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.2",
    "id" : 43,
    "size" : "675,11 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.3",
    "id" : 44,
    "size" : "46,05 KB",
    "extension" : ".docx"
  } ]
}, {
  "id" : 6,
  "name" : "Общевоинские уставы",
  "files" : [ {
    "name" : "Тема 1.1",
    "id" : 45,
    "size" : "27,29 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.1",
    "id" : 46,
    "size" : "16,89 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.1",
    "id" : 47,
    "size" : "29,42 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.2",
    "id" : 48,
    "size" : "27,46 KB",
    "extension" : ".docx"
  }, {
    "name" : "тема 3.3 уст разв",
    "id" : 49,
    "size" : "37,29 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.4 уст зазв",
    "id" : 50,
    "size" : "24,21 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 4.1 уст  разв",
    "id" : 51,
    "size" : "26,65 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 5.1",
    "id" : 52,
    "size" : "37,14 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 5.2 уставы",
    "id" : 53,
    "size" : "38,23 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 5.3",
    "id" : 54,
    "size" : "39,68 KB",
    "extension" : ".docx"
  }, {
    "name" : "тема 6.1 уставы",
    "id" : 55,
    "size" : "926,57 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 7.1 уставы",
    "id" : 56,
    "size" : "736,13 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 7.2",
    "id" : 57,
    "size" : "22,48 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 7.3",
    "id" : 58,
    "size" : "17,52 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 7.4",
    "id" : 59,
    "size" : "461,89 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 7.5",
    "id" : 60,
    "size" : "12,58 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 8",
    "id" : 61,
    "size" : "132,68 KB",
    "extension" : ".docx"
  } ]
}, {
  "id" : 7,
  "name" : "Огневая подготовка",
  "files" : [ {
    "name" : "Тема 1.1",
    "id" : 62,
    "size" : "23,14 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 1.2",
    "id" : 63,
    "size" : "120,65 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.2 огневя",
    "id" : 64,
    "size" : "305,94 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.3 огнев",
    "id" : 65,
    "size" : "439,76 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.1 огнев",
    "id" : 66,
    "size" : "604,41 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.2огнев",
    "id" : 67,
    "size" : "45,04 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.3 огневая",
    "id" : 68,
    "size" : "172,05 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.4",
    "id" : 69,
    "size" : "574,12 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.5",
    "id" : 70,
    "size" : "584,18 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.6",
    "id" : 71,
    "size" : "37,50 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.7",
    "id" : 72,
    "size" : "242,90 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.8",
    "id" : 73,
    "size" : "120,68 KB",
    "extension" : ".docx"
  }, {
    "name" : "тема 4.1",
    "id" : 74,
    "size" : "328,89 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 4.2",
    "id" : 75,
    "size" : "32,38 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 5.1",
    "id" : 76,
    "size" : "171,10 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 5.2",
    "id" : 77,
    "size" : "62,38 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 6.1",
    "id" : 78,
    "size" : "157,46 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 6.2",
    "id" : 79,
    "size" : "18,30 KB",
    "extension" : ".docx"
  } ]
}, {
  "id" : 8,
  "name" : "Разведовательная подготовка",
  "files" : [ {
    "name" : "Тема 1.1",
    "id" : 80,
    "size" : "1,49 MB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 1.2",
    "id" : 81,
    "size" : "78,17 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.1",
    "id" : 82,
    "size" : "1,56 MB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.2",
    "id" : 83,
    "size" : "454,66 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.3",
    "id" : 84,
    "size" : "1,52 MB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.4  раз   разв",
    "id" : 85,
    "size" : "527,10 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.5   разв   разв",
    "id" : 86,
    "size" : "32,04 KB",
    "extension" : ".docx"
  } ]
}, {
  "id" : 9,
  "name" : "Связь",
  "files" : [ {
    "name" : "связь т 1 зан 1 разв",
    "id" : 87,
    "size" : "118,79 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 1.2",
    "id" : 88,
    "size" : "563,92 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.1 связь разв",
    "id" : 89,
    "size" : "378,30 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.2",
    "id" : 90,
    "size" : "378,30 KB",
    "extension" : ".docx"
  } ]
}, {
  "id" : 10,
  "name" : "Строевая подготовка",
  "files" : [ {
    "name" : "Тема 1.1",
    "id" : 91,
    "size" : "20,89 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.1- 4 стр разв  к",
    "id" : 92,
    "size" : "305,29 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.5-8",
    "id" : 93,
    "size" : "12,98 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.9-10",
    "id" : 94,
    "size" : "12,99 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.1-2",
    "id" : 95,
    "size" : "475,16 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 4.1-4",
    "id" : 96,
    "size" : "170,59 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 4.5-8",
    "id" : 97,
    "size" : "14,36 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 5.1-4",
    "id" : 98,
    "size" : "22,40 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 5.5-8",
    "id" : 99,
    "size" : "0 B",
    "extension" : ".docx"
  } ]
}, {
  "id" : 11,
  "name" : "Тактическая подготовка",
  "files" : [ {
    "name" : "Тема 1",
    "id" : 100,
    "size" : "28,16 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 10.1",
    "id" : 101,
    "size" : "382,71 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 11.1",
    "id" : 102,
    "size" : "202,79 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 11.2",
    "id" : 103,
    "size" : "217,49 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 12.1_такт_разверн",
    "id" : 104,
    "size" : "42,32 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 12.2 такт разв",
    "id" : 105,
    "size" : "27,75 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 13.1такт   развернут",
    "id" : 106,
    "size" : "507,95 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 13.2такт   разв",
    "id" : 107,
    "size" : "441,54 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 14.1 такт разв",
    "id" : 108,
    "size" : "1,56 MB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 14.2 такт рав",
    "id" : 109,
    "size" : "550,61 KB",
    "extension" : ".docx"
  }, {
    "name" : "тема 14.3 такт разв",
    "id" : 110,
    "size" : "1,55 MB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 14.4   такт разв",
    "id" : 111,
    "size" : "51,20 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.1",
    "id" : 112,
    "size" : "62,82 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.10",
    "id" : 113,
    "size" : "33,71 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.11",
    "id" : 114,
    "size" : "36,78 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.2",
    "id" : 115,
    "size" : "339,03 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.3",
    "id" : 116,
    "size" : "149,72 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.4",
    "id" : 117,
    "size" : "256,67 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.6 такт",
    "id" : 118,
    "size" : "211,76 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.7 такт",
    "id" : 119,
    "size" : "101,65 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.8 так разв",
    "id" : 120,
    "size" : "65,41 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.9",
    "id" : 121,
    "size" : "96,34 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.1",
    "id" : 122,
    "size" : "739,24 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.2",
    "id" : 123,
    "size" : "630,61 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 4.1",
    "id" : 124,
    "size" : "415,28 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 5.1",
    "id" : 125,
    "size" : "32,36 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 6.1",
    "id" : 126,
    "size" : "30,58 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 6.2",
    "id" : 127,
    "size" : "162,42 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 6.3",
    "id" : 128,
    "size" : "238,03 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 7.1",
    "id" : 129,
    "size" : "232,30 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 7.2",
    "id" : 130,
    "size" : "28,89 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 7.3",
    "id" : 131,
    "size" : "27,13 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 8.1",
    "id" : 132,
    "size" : "25,47 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 8.2  уст  разв",
    "id" : 133,
    "size" : "24,90 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 8.2",
    "id" : 134,
    "size" : "271,15 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 9.1",
    "id" : 135,
    "size" : "242,16 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 9.2",
    "id" : 136,
    "size" : "238,70 KB",
    "extension" : ".docx"
  } ]
}, {
  "id" : 12,
  "name" : "Техническая подготовка",
  "files" : [ {
    "name" : "Тема 1.1",
    "id" : 137,
    "size" : "353,85 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 1.2 нов",
    "id" : 138,
    "size" : "1,40 MB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 1.2",
    "id" : 139,
    "size" : "25,99 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.1",
    "id" : 140,
    "size" : "877,22 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.2",
    "id" : 141,
    "size" : "27,40 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.3",
    "id" : 142,
    "size" : "16,96 KB",
    "extension" : ".docx"
  } ]
}, {
  "id" : 13,
  "name" : "Физическая подготовка",
  "files" : [ {
    "name" : "Тема 1.1",
    "id" : 143,
    "size" : "52,61 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 1.2",
    "id" : 144,
    "size" : "15,79 KB",
    "extension" : ".docx"
  } ]
}, {
  "id" : 14,
  "name" : "Юридическая подготовка",
  "files" : [ {
    "name" : "Тема 1.1",
    "id" : 145,
    "size" : "79,98 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 2.1",
    "id" : 146,
    "size" : "20,01 KB",
    "extension" : ".docx"
  }, {
    "name" : "Тема 3.1",
    "id" : 147,
    "size" : "16,63 KB",
    "extension" : ".docx"
  }, {
    "name" : "юридит подготовка Т2 зан 2 —РАЗВ",
    "id" : 148,
    "size" : "421,50 KB",
    "extension" : ".doc"
  }, {
    "name" : "юридит подготовка Т2 зан 2",
    "id" : 149,
    "size" : "31,50 KB",
    "extension" : ".doc"
  }, {
    "name" : "юридит подготовка Т3 зан 1  разв",
    "id" : 150,
    "size" : "56,50 KB",
    "extension" : ".doc"
  } ]
} ];